module.exports = __webpack_public_path__ + "static/mouth-mask-standards-from-china-f67671df13d1e9eccdc584ca785ea0b5.png";